PJQ.views.timecards.TimeCardSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-timecard-settings'),
        width: '400px'
    },
    events: {
        'change .select-column': 'columnSelected',
        'click button.settings-save': 'onSave',
        'click .btn-geofence': 'manageProjectGeofence'
    },
    beforeModalCreated: function () {
        this.model = this.options.timecardsView.userSettings;
    },
    beforeRender: function () {
        // copy settings for our UI; we only update global settings object on save.
        this.options.settings = [];
        this.options.defaultView = this.model.get('defaultView');
        this.options.defaultDateRange = this.model.get('defaultDateRange');
        _.each(this.model.attributes.viewSettings, _.bind(function (setting) {
            if (setting.view === PJQ.constants.timecards.view.BY_CONTACT_PROJECT_TIMECARD ||
                setting.view === PJQ.constants.timecards.view.BY_PROJECT_CONTACT_TIMECARD)
                return;

            let columns = this.options.timecardsView.getDataTableInstance({
                    view: setting.view,
                    timeCardSettings: this.options.timecardsView.settings,
                    settings: this.model.getSettings(setting.view)
                }).getColumns(true)

            columns =  _.filter(columns, (col) => {
                return col.visible !== false;
            })

            let selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.settings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.timecardsView.options.project
        }
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view-default'),
            defaultValue: this.options.defaultView,
            onChange: _.bind(function (value) {
                this.options.defaultView = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-date-range-default'),
            defaultValue: this.options.defaultDateRange,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.options.defaultDateRange = value;
            }, this)

        });

        new PJQ.inputs.Selectpicker({
            el: this.$('select.select-view'),
            defaultValue: this.options.timecardsView.dataTable.options.view,
            onChange: _.bind(function (value) {
                this.selectView(value);
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(this.options.timecardsView.dataTable.options.view);
    },
    manageProjectGeofence: function () {
        new PJQ.views.timecards.TimeCardGeofenceModal({});
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.settings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.$('div.rows-per-page').show();
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
        } else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            order: [],
            pageLength: 5,
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {
        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.model.set('defaultView', this.options.defaultView);
        this.model.set('defaultDateRange', this.options.defaultDateRange);

        _.each(this.options.settings, _.bind(function (settingTemp) {
            _.each(this.model.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        } else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        //save settings to database
        this.model.save(null, {
            success: _.bind(function () {
                this.model.set('defaultView', this.options.defaultView);
                fnOnSave();
            }, this)
        });
    }
});

PJQ.views.timecards.TimeCardGeofenceModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-timecard-geofence'),
        minWidth: '700px'
    },
    events: {
        'keyup .input-longitude, .input-latitude, .input-radius': 'positionChanged',
        'click .btn-save': 'save',
        'click .cb-enable-geofence': 'toggleStatus'
    },
    beforeModalCreated: function () {
        this.settings = new PJQ.models.timecards.TimeCardSettings(null, {
            project: PJQ.app.session.project
        });

        this.geofenceEnabled = false;

        if (!this.settings.isFetched) {
            this.settings.fetch({
                success: _.bind(function () {
                    if (this.settings.get('geofence')) {
                        this.geofence = this.settings.get('geofence');
                        this.geofenceEnabled = this.geofence.latitude && this.geofence.longitude;
                    } else {
                        let defaultLat = PJQ.app.session.project.get('latitude'),
                            defaultLong = PJQ.app.session.project.get('longitude');
                        this.geofence = {
                            radius: 1000,
                            longitude: defaultLong !== 0 ? defaultLong : null,
                            latitude: defaultLat !== 0 ? defaultLat : null
                        };
                    }

                    this.isFetched = true;
                    this.render();
                }, this)
            })
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    renderData: function () {
        return {
            geofence: this.geofence,
            geofenceEnabled: this.geofenceEnabled
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        if (this.settings && this.settings.isFetched) {
            this.renderMap();
        }
    },
    toggleStatus: function () {
        this.geofenceEnabled = !this.geofenceEnabled;
    },
    renderMap: function () {
        this.geofenceMap = new PJQ.maps.GoogleMap(this.$('.geofence-map'));
        if (this.geofence.latitude && this.geofence.longitude) {
            this.refreshMarkers();
        }

        // Listen for clicks on the map to set/move the marker and radius circle
        this.geofenceMap.map.addListener('click', _.bind((data) => {
            // Reduce the lat/long to 7 decimal places
            this.geofence.latitude = Math.round(data.latLng.lat() * 10000000) / 10000000;
            this.geofence.longitude = Math.round(data.latLng.lng() * 10000000) / 10000000;
            this.geofenceEnabled = true;

            this.$('.cb-enable-geofence').prop('checked', true);
            this.$('.input-latitude').val(this.geofence.latitude);
            this.$('.input-longitude').val(this.geofence.longitude);

            this.refreshMarkers();
        }, this));
    },
    positionChanged: function (e) {
        let $target = $(e.currentTarget),
            valueType = $target.data('type'),
            value = $target.val();

        // Radius should always have a value
        if (valueType.toLowerCase() === 'radius') {
            value = parseInt(value);
            if (isNaN(value) || value < 0) {
                value = 0;
            }
            this.$('.input-radius').val(value);
        }

        this.geofence[valueType] = value;

        if (this.geofence.latitude && this.geofence.longitude) {
            this.refreshMarkers();
        }
    },
    refreshMarkers: function () {
        let positionObject = new google.maps.LatLng(this.geofence.latitude, this.geofence.longitude);

        if (this.geofence.radius == null) {
            this.geofence.radius = 1000;
            this.$('.input-radius').val(this.geofence.radius);
        }

        // if no marker and circle exist, create them
        if (!this.marker && !this.circle) {
            this.circle = new google.maps.Circle({
                map: this.geofenceMap.map,
                radius: this.geofence.radius ? this.geofence.radius : 1000,
                fillColor: '#41c1e1',
                fillOpacity: 0.35,
                strokeColor: '#148fb2',
                strokeOpacity: 0.8,
                strokeWeight: 1,
                center: positionObject,
                clickable: false
            });

            this.marker = new google.maps.Marker({
                position: positionObject,
                map: this.geofenceMap.map,
                title: 'Geofence Center',
                animation: google.maps.Animation.DROP
            });

            // Zoom and center map on marker when clicked
            this.marker.addListener('click', _.bind(function () {
                this.geofenceMap.setCenter(this.marker.getPosition());
                this.geofenceMap.setZoom(10);
            }, this));

            // Zoom and center map on marker on creation
            this.geofenceMap.setCenter(this.marker.getPosition());
            this.geofenceMap.setZoom(10);
        } else {
            this.marker.setPosition(positionObject);
            this.circle.setCenter(positionObject);
            this.circle.setRadius(this.geofence.radius);
        }
    },
    save: function () {
        if (!this.geofenceEnabled) {
            this.geofence.latitude = null;
            this.geofence.longitude = null;
        }

        this.settings.set('geofence', this.geofence);
        this.settings.save(null, {
            success: _.bind(function () {
                this.removeModal();
            }, this)
        })
    }
});

PJQ.views.timecards.TimeCardLocationMapModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.TIMECARDS, 'modal-timecard-location-map'),
        minWidth: '700px',
        coordinatesIn: null,
        coordinatesOut: null
    },
    afterRender: function () {
        this.renderMap();
    },
    renderMap: function () {
        this.map = new PJQ.maps.GoogleMap(this.$('.timecard-location-map'));
        this.renderMarkers();
    },
    renderMarkers: function () {
        let inMarker = null,
            outMarker = null
        if (this.model.get('latitudeIn') && this.model.get('longitudeIn')) {
            inMarker = new google.maps.Marker({
                position: new google.maps.LatLng(this.model.get('latitudeIn'), this.model.get('longitudeIn')),
                map: this.map.map,
                title: 'Clock In Location',
                animation: google.maps.Animation.DROP,
                icon: {
                    url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                }
            });

            // Clock in info window
            let infoWindowContent = "<div class='p-1 text-align-center'><div class='font-weight-bold mb-1'>Clocked In</div>";

            if (this.model.get('timeIn')) {
                infoWindowContent += "<div>" + PJQ.helpers.dateHelpers.getDateString(this.model.get('timeIn'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "</div>";
            }
            infoWindowContent += "</div>"

            let infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });
            inMarker.addListener('click', function () {
                infoWindow.open(this.map, inMarker);
            });
        }

        if (this.model.get('latitudeOut') && this.model.get('longitudeOut')) {
            outMarker = new google.maps.Marker({
                position: new google.maps.LatLng(this.model.get('latitudeOut'), this.model.get('longitudeOut')),
                map: this.map.map,
                title: 'Clock Out Location',
                animation: google.maps.Animation.DROP,
                icon: {
                    url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                }
            });

            // Clock out info window
            let infoWindowContent = "<div class='p-1 text-align-center'><div class='font-weight-bold mb-1'>Clocked Out</div>";

            if (this.model.get('timeOut')) {
                infoWindowContent += "<div>" + PJQ.helpers.dateHelpers.getDateString(this.model.get('timeOut'), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME) + "</div>";
            }
            infoWindowContent += "</div>"

            let infoWindow = new google.maps.InfoWindow({
                content: infoWindowContent
            });
            outMarker.addListener('click', function () {
                infoWindow.open(this.map, outMarker);
            });
        }

        if (inMarker || outMarker) {
            this.map.setCenter(inMarker ? inMarker.getPosition() : outMarker.getPosition());
            this.map.setZoom(10);
        }
    }
});